var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.1413,
    height: 3.14267,
    rx: 1.57133,
    transform: "matrix(0.7071 0.707114 -0.7071 0.707114 4.22235 2)",
    fill: "#002F6C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25.1413,
    height: 3.14267,
    rx: 1.57133,
    transform: "matrix(-0.7071 0.707114 0.7071 0.707114 19.7774 2)",
    fill: "#002F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.c30ef4ff526f33209b77584d8f7bf593.svg";
export { ForwardRef as ReactComponent };